import React from 'react';
import { Box } from '@mui/material';
import ViewToggle from './ViewToggle';
import ServicesGantt from '../ServicesGantt';
import { useFilters } from 'components/Elements/Filters/FilterContext';

const ServicesView = ({ children }) => {
	const { filterValues } = useFilters();
	
	// Get current view from filter state, defaulting to 'table'
	const view = filterValues.viewToggle?.value?.id || 'table';

	const handleViewChange = (newView) => {
		// ViewToggle component will handle the filter update
		// This is kept for compatibility but the actual state management
		// is now handled by the filter framework
	};

	return (
		<Box>
			<Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
				<ViewToggle onViewChange={handleViewChange} />
			</Box>
			
			{view === 'table' ? (
				<Box>
					{children}
				</Box>
			) : (
				<ServicesGantt />
			)}
		</Box>
	);
};

export default ServicesView;